<template>
  <div>
    <!-- Wheel of luck page -->
    <v-col
      v-show="cardState.length > 0"
      cols="12"
      sm="12"
      md="8"
      dir="rtl"
      class="pa-4 mx-auto position-sticky"
      id="error"
      style="position: sticky; top: 40%"
    >
      <v-card outlined class="luck_card rounded-xl ma-0 pa-2 cardMargin">
        <div class="d-flex flex-column justify-center align-center">
          <v-card-title class="wheel_title pa-1" spellcheck="false">
            {{ cardState }}
          </v-card-title>
        </div>
      </v-card>
    </v-col>
    <v-row class="center_in_page justify-center align-center ma-0 cardmargin">
      <!-- Fortune wheel -->
      <!-- Welcome and get information -->

      <v-col
        v-show="showcard"
        cols="12"
        sm="12"
        md="5"
        dir="rtl"
        class="pa-4"
        id="showCard"
      >
        <v-card outlined class="luck_card rounded-xl ma-0 pa-2 cardMargin">
          <div class="d-flex flex-column justify-center align-center">
            <!-- Topic -->
            <v-card-title class="wheel_title pa-1" spellcheck="false">
              گردونه شانس {{ infoLuck.business_name }}
            </v-card-title>
            <!-- Funny sentence -->
            <v-card-title class="wheel_subtitle pa-1">
              {{ infoLuck.customer ? infoLuck.customer.name : "" }}
            </v-card-title>
            <!-- <v-card-title class="wheel_subtitle pa-1">
              شانس خودت رو بساز!!!
            </v-card-title> -->
            <!-- Give me your birthday -->
            <v-card-title class="wheel_text pa-1">
              تاریخ تولدت رو وارد کن تا شانست محک بخوره!!!
            </v-card-title>
            <!-- Get user's birthday -->
            <v-form class="pa-2" ref="form" v-model="valid" lazy-validation>
              <div class="d-flex flex-column align-center">
                <my-date-picker
                  v-model="date"
                  simple
                  custom-input=".wheel_birth_field"
                />

                <v-text-field
                  class="wheel_birth_field rounded-xl my-2 mx-0"
                  color="#f77f00"
                  :value="newDate"
                  dir="ltr"
                  solo
                  dark
                  hide-details
                  readonly
                  placeholder="تاریخ تولد"
                  prepend-icon="mdi-cake-variant-outline"
                  @click:clear="date = null"
                ></v-text-field>

                <v-btn
                  id="luck_button"
                  class="ma-2 rounded-xl"
                  dark
                  block
                  color="#f77f00"
                  large
                  @click="
                    // loader = 'loading';
                    startCallback();
                    clicked = true;
                  "
                  :disabled="!date || clicked"
                >
                  بزن بریم
                </v-btn>
              </div>

              <!-- <v-dialog ref="dialog" v-model="modal" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="wheel_birth_field rounded-xl"
                        color="#ffee32"
                        :value="computedDateFormattedMomentjs"
                        dir="ltr"
                        solo
                        dark
                        hide-details
                        readonly
                        prepend-icon="mdi-cake-variant-outline"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="date = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      class="rounded-xl"
                      locale="fa_IR"
                      dir="rtl"
                      no-title
                      dark
                      color="#f77f00"
                      prev-icon="mdi-chevron-right"
                      next-icon="mdi-chevron-left"
                      scrollable
                      :first-day-of-week="6"
                    >
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)"
                      >
                        OK
                      </v-btn></v-date-picker
                    >
                  </v-dialog> -->
            </v-form>
            <!-- <div v-show="prize">
              <v-card-title class="wheel_text pa-1">
                شما برنده {{ prize.name ? prize.name : "" }} شده اید.
              </v-card-title>
            </div> -->
          </div>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        id="canvasLucky"
        style="text-align: -webkit-center; font-family: iranyekan !important"
      >
        <LuckyWheel
          id="canvas"
          class="luckyWheel animate__animated animate__jackInTheBox animate__slow"
          ref="myLucky"
          width="400px"
          height="500px"
          :defaultConfig="defaultConfig"
          :defaultStyle="defaultStyle"
          :prizes="arrayPrize"
          :blocks="blocks"
          :buttons="buttons"
          @start="startCallback"
          @end="endCallback"
        />
      </v-col>
    </v-row>
    <audio id="winner" preload="auto">
      <source src="../assets/audio/youwin.wav" />
    </audio>
    <audio id="loser" preload="auto">
      <source src="../assets/audio/loser.mp3" />
    </audio>
  </div>
</template>
<script>
import moment from "moment";
import { format, parseISO } from "date-fns-jalali";

export default {
  data() {
    return {
      query: this.$route.query.link,
      infoLuck: [],
      showcard: true,

      blocks: [
        {
          padding: "55px",
          imgs: [
            {
              src: "https://spinner.namya.ir/image/background.png",
              top: "-5",
              left: "0",
            },
          ],
        },
      ],

      // Center Button
      buttons: [
        { radius: "35%", background: "#F00000" },
        { radius: "30%", background: "#FFFDD0" },
        {
          radius: "25%",
          background: "#696969",
          pointer: true,
          fonts: [
            {
              text: "بچرخون",
              top: "-7px",
              fontSize: "15px",
              fontColor: "#FFD700",
            },
          ],
        },
        // { radius: "20%", background: "#F00000" },
        // {
        //   radius: "17%",
        //   imgs: [
        //     {
        //       src: "https://spinner.namya.ir/image/wheel-center.png",
        //       width: "140%",
        //       height: "140%",
        //       top: "-30px",
        //     },
        //   ],
        // },
        {
          radius: "17%",
          imgs: [
            {
              src: "https://spinner.namya.ir/image/indicator.png",
              width: "50px",
              height: "48px",
              top: "-175px",
            },
          ],
        },
        // { radius: "10%", background: "#1f1f1f" },
      ],
      defaultStyle: {
        fontStyle: "iranyekan",
        fontWeight: "700",
        lineHeight: "10",
        wordWrap: "true",
        lengthLimit: "85%",
        lineClamp: "100",
      },
      defaultConfig: {
        gutter: "5px",
      },

      arrayPrize: [],
      prize: [],
      cardState: "",

      // Date format
      date: "",
      dateapi: "",
      modal: false,
      valid: null,

      // Loading button
      // index: -1,
      // loader: null,
      // loading: false,
      clicked: false,
    };
  },

  computed: {
    computedDateFormattedMomentjs() {
      return this.date
        ? moment(format(parseISO(this.date), "yyyy-MM-dd")).format("YYYY/MM/DD")
        : "";
    },
    newDate() {
      return this.date
        ? new Date(this.date).toLocaleDateString("fa-IR")
        : this.dateapi;
    },
  },

  created() {
    this.getInfoLuck();
  },

  methods: {
    async getInfoLuck() {
      let response = await this.axios
        .get(
          "https://namya.ir/api/v3/lucky-wheel/show?link=" + this.query
          // YPYOZh8R
        )
        .then((response) => {
          this.infoLuck = response.data.data;
          this.dateapi = this.infoLuck.customer
            ? this.infoLuck.customer.birth_date
            : "";
          for (let i = 0; i < this.infoLuck.lucky_wheel_prize.length; i++) {
            this.arrayPrize.push(this.infoLuck.lucky_wheel_prize[i]);
            const customItem = {
              text: this.PersianDigitsToEnglishDigits(
                this.infoLuck.lucky_wheel_prize[i].name
              ).match(/^\d+/)
                ? this.PersianDigitsToEnglishDigits(
                    this.infoLuck.lucky_wheel_prize[i].name
                  ).match(/^\d+/)[0] +
                  this.PersianDigitsToEnglishDigits(
                    this.infoLuck.lucky_wheel_prize[i].name
                  ).match(/\D+/)[0]
                : this.infoLuck.lucky_wheel_prize[i].name,
              top: "15%",
              fontStyle: "iranyekan",
              fontSize: 12,
              fontWeight: "500",
              lineHeight: "25",
              lengthLimit: "85%",
            };

            var font = [];
            font.push(customItem);
            this.infoLuck.lucky_wheel_prize[i].fonts = font;
            let colors = [
              "#5fbc5e",
              "#0aab94",
              "#FFDDFF",
              "#FFD700",
              "#5fbc5e",
            ];
            if (i <= 4) {
              this.infoLuck.lucky_wheel_prize[i].background = colors[i];
            } else {
              this.infoLuck.lucky_wheel_prize[i].background = colors[i - 4];
            }
            // if (i % 2 == 0) {
            //   this.infoLuck.lucky_wheel_prize[i].background = "#5fbc5e";
            // } else {
            //   this.infoLuck.lucky_wheel_prize[i].background = "#0aab94 ";
            // }
          }
          this.$refs.myLucky.lucky.ctx.direction = "rtl";
          this.$refs.myLucky.lucky.ctx.textAlign = "end";
          this.$refs.myLucky.lucky.ctx.font = "10px iranyekan";
          console.warn("arrayPrize :", this.arrayPrize);
        })
        .catch((error) => {
          setTimeout(() => {
            var showCard = document.getElementById("showCard");
            showCard.classList.add(
              "animate__animated",
              "animate__bounceOutLeft",
              "animate__slow"
            );
            var canvasLucky = document.getElementById("canvasLucky");
            canvasLucky.classList.add(
              "animate__animated",
              "animate__zoomOut",
              "animate__slower"
            );
            this.$swal({
              // title: '<strong>HTML <u>example</u></strong>',
              text: error.response.data.message,
              icon: "error",
              width: 600,
              color: "#f5f5f5",
              padding: "1em",
              background: "#1f1f1fe6",
              confirmButtonText: "بستن",
            });
            this.cardState = error.response.data.message;
          }, 3000);
        });
    },
    PersianDigitsToEnglishDigits(strString) {
      const arrEnglishDigits = {
        "٠": 0,
        "١": 1,
        "٢": 2,
        "٣": 3,
        "٤": 4,
        "٥": 5,
        "٦": 6,
        "٧": 7,
        "٨": 8,
        "٩": 9,
        "۰": 0,
        "۱": 1,
        "۲": 2,
        "۳": 3,
        "۴": 4,
        "۵": 5,
        "۶": 6,
        "۷": 7,
        "۸": 8,
        "۹": 9,
      };

      return strString
        .replace(/[٠-٩۰-۹]/g, function (strOccurrences) {
          return arrEnglishDigits[strOccurrences];
        })
        .replace(/،/g, ",");
    },

    async startCallback() {
      var max = this.arrayPrize.length;
      this.$refs.myLucky.play();
      var showCard = document.getElementById("showCard");
      showCard.classList.add(
        "animate__animated",
        "animate__bounceOutLeft",
        "animate__slow"
      );
      setTimeout(() => {
        showCard.classList.add("d-none");
      }, 700);
      // To generate random number
      // var index = Math.floor(Math.random() * (max - 0) + 0);
      let response = await this.axios
        .post(
          "https://namya.ir/api/v3/lucky-wheel/spin",
          {
            link: this.$route.query.link,
            birth_date: this.date,
          }
          // YPYOZh8R
        )
        .then((response) => {
          this.prize = response.data.data;
          var simple = this.arrayPrize.filter(
            (simpleprize) => simpleprize.id == this.prize.id
          );
          if (simple) {
            var elementPos = this.arrayPrize
              .map(function (x) {
                return x.id;
              })
              .indexOf(simple[0].id);
            var index = elementPos;
          }
          setTimeout(() => {
            this.$refs.myLucky.stop(index);
            var canvasLucky = document.getElementById("canvasLucky");
            setTimeout(() => {
              canvasLucky.classList.add(
                "animate__animated",
                "animate__zoomOut",
                "animate__slow"
              );
            }, 5200);
            this.$refs.myLucky.lucky.ctx.direction = "rtl";
            this.$refs.myLucky.lucky.ctx.textAlign = "end";
            this.$refs.myLucky.lucky.ctx.font = "10px iranyekan";
            setTimeout(() => {
              if (this.prize.name != "پوچ") {
                this.$confetti.start({
                  particles: [
                    {
                      type: "heart",
                    },
                  ],
                  defaultColors: ["red", "pink", "#ba0000"],
                });
              }
              this.cardState =
                "تبریک! " + "شما برنده " + this.prize.name + " شده اید";
              this.$swal({
                titleText:
                  this.prize.name != "پوچ"
                    ? "تبریک! " + "شما برنده " + this.prize.name + " شده اید"
                    : "متاسفانه رو دور شانس نیستی!",
                text: this.prize.value ? "کد تخفیف : " + this.prize.value : "",
                icon: this.prize.name != "پوچ" ? "success" : "waring",
                width: 500,
                color: "#f5f5f5",
                padding: "0.8em",
                background: "#1f1f1fe6",
                confirmButtonText: "بستن",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$confetti.stop();
                  if (this.prize.name != "پوچ") {
                    winner.pause();
                  } else {
                    loser.pause();
                  }
                  winner.currentTime = 0;
                }
              });
              if (this.prize.name != "پوچ") {
                winner.play();
              } else {
                loser.play();
              }
            }, 3000);
          }, 3000);
        })
        .catch((error) => {
          // error.response.data.message;
          setTimeout(() => {
            this.$refs.myLucky.stop(-1);
            var canvasLucky = document.getElementById("canvasLucky");
            canvasLucky.classList.add(
              "animate__animated",
              "animate__zoomOut",
              "animate__slower"
            );

            this.$swal({
              // title: '<strong>HTML <u>example</u></strong>',
              text: error.response.data.message,
              icon: "error",
              width: 600,
              color: "#f5f5f5",
              padding: "1em",
              background: "#1f1f1fe6",
              confirmButtonText: "بستن",
            });
            this.cardState = error.response.data.message;
          }, 3000);
        });
    },

    endCallback(prize) {
      console.log(prize);
    },
    checktext() {},
  },
};
</script>

<style scoped>
.center_in_page {
  height: 100%;
}

.luck_card {
  /* border-width: 3px;
  border-style: solid;
  border-image: linear-gradient(to bottom, #ffee32, rgb(255, 0, 0)) 1 100%; */
  border: 2px solid #ffee32 !important;
  background-color: transparent;
}

.wheel_title {
  color: #ffee32;
  font-size: 1.1rem !important;
}

.wheel_subtitle {
  color: #f5f5f5;
  font-size: 0.9rem !important;
  font-weight: 800 !important;
}

.wheel_text {
  color: #f5f5f5;
  font-size: 0.8rem !important;
  font-weight: 800 !important;
}

.wheel_birth_field {
  border: 2px solid #ffee32 !important;
  background-color: unset !important;
  /* box-shadow: rgba(255, 238, 50, 0.4) -5px 5px; */
}

*
  >>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
}

* >>> .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: none;
}

* >>> .theme--dark.v-icon {
  color: #f77f00;
}

* >>> .theme--dark.v-picker__body {
  background: #1f1f1f;
}

* >>> .vpd-simple-content {
  background-color: #1f1f1f;
  padding: 5px;
}

* >>> .vpd-simple-content .vpd-column .vpd-column-header {
  color: #f5f5f5;
  line-height: 40px !important;
  height: unset;
}

* >>> .vpd-simple-content .vpd-addon-list-item {
  border: unset;
  border-radius: 10px;
}

* >>> .vpd-addon-list-item {
  color: #6c757d;
}

* >>> .vpd-addon-list-item.vpd-selected {
  background-color: #f77f00 !important;
  color: #f5f5f5 !important;
}

* >>> .vpd-addon-list-item.vpd-selected,
* >>> .vpd-addon-list-item:hover {
  background-color: #343a40;
  color: #f5f5f5;
}

* >>> .vpd-input-group label {
  display: none;
}

/* @media only screen and (min-width: 980px) {
  .cardmargin {
    margin-top: 100px !important;
  }
} */
.glow {
  color: #fff;
  text-align: center;
  animation: glow 1s ease-in-out infinite alternate !important;
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #d7e600,
      0 0 40px #d7e600, 0 0 50px #d7e600, 0 0 60px #d7e600, 0 0 70px #d7e600;
  }

  to {
    text-shadow: 0 0 20px #fff, 0 0 30px #e1ff4d, 0 0 40px #e1ff4d,
      0 0 50px #e1ff4d, 0 0 60px #e1ff4d, 0 0 70px #e1ff4d, 0 0 80px #e1ff4d;
  }
}
div.vpd-content {
  --border-size: 3px;
  --border-angle: 0turn;
  border-radius: 5px !important;
  background-image: conic-gradient(
      from var(--border-angle),
      rgb(26, 23, 29),
      rgb(11, 11, 23) 50%,
      rgb(26, 23, 29)
    ),
    conic-gradient(from var(--border-angle), transparent 20%, #08f, #f03);
  background-size: calc(100% - (var(--border-size) * 2))
      calc(100% - (var(--border-size) * 2)),
    cover;
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-animation: bg-spin 3s linear infinite;
  animation: bg-spin 3s linear infinite;
}

.box {
  --border-size: 3px;
  --border-angle: 0turn;
  border-radius: 5px !important;
  background-image: conic-gradient(
      from var(--border-angle),
      rgb(26, 23, 29),
      rgb(11, 11, 23) 50%,
      rgb(26, 23, 29)
    ),
    conic-gradient(
      from var(--border-angle),
      transparent 20%,
      rgb(214, 176, 6),
      rgb(211, 116, 0)
    );
  background-size: calc(100% - (var(--border-size) * 2))
      calc(100% - (var(--border-size) * 2)),
    cover;
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-animation: bg-spin 3s linear infinite;
  animation: bg-spin 3s linear infinite;
}
@-webkit-keyframes bg-spin {
  to {
    --border-angle: 1turn;
  }
}
@keyframes bg-spin {
  to {
    --border-angle: 1turn;
  }
}
/* .box:hover {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
} */

@property --border-angle {
  syntax: "<angle>";
  inherits: true;
  initial-value: 0turn;
}
.neon {
  font-size: 10px;
  font-weight: 700;
  color: rgb(255, 238, 50);
  color: linear-gradient(
    90deg,
    rgba(255, 238, 50, 1) 20%,
    rgba(247, 169, 0, 1) 80%
  );
  padding: 3rem 5rem 4.4rem;
  border: 0.2 rem solid #f5f5f5;
  border-radius: 1rem;
  text-transform: uppercase;
  animation: flicker 1.5s infinite alternate;
}

.neon::-moz-selection {
  background-color: #08f;
  color: #f40;
}

.neon::selection {
  background-color: #08f;
  color: #f40;
}

.neon:focus {
  outline: none;
}

/* Animate neon flicker */
@keyframes flicker {
  0%,
  19%,
  21%,
  23%,
  25%,
  54%,
  56%,
  100% {
    text-shadow: -0.1rem -0.1rem 0.9rem #fff, 0.1rem 0.1rem 0.9rem #fff,
      0 0 2rem #f40, 0 0 4rem #f40, 0 0 6rem #f40, 0 0 8rem #f40, 0 0 10rem #f40;

    box-shadow: 0 0 0.5rem #fff, inset 0 0 0.5rem #fff, 0 0 2rem #08f,
      inset 0 0 2rem #08f, 0 0 4rem #08f, inset 0 0 4rem #08f;
  }

  20%,
  24%,
  55% {
    text-shadow: none;
    box-shadow: none;
  }
}
.luckyWheel {
  /* box-shadow: inset 0 0 50px #fff, inset 20px 0 80px #ffee32,
    inset -20px 0 80px #f77f00, inset 20px 0 300px #ffee32,
    inset -20px 0 300px #f77f00, 0 0 50px #fff, -10px 0 80px #ffee32,
    10px 0 80px #f77f00 !important; */
  /* border-radius: 50%; */
  margin: -32px !important;
}

@media only screen and (max-width: 300px) {
  .luckyWheel {
    width: 300px !important;
    height: 300px !important;
  }

  * >>> div > canvas {
    transform: scale(0.38) !important;
  }
}

/* div:where(.swal2-container) div:where(.swal2-popup) {
  border: 1.5px solid #ffee32 !important;
  border-radius: 15px !important;
} */
div.swal2-popup.swal2-modal.swal2-icon-error.swal2-show {
  border: 2px solid #f17474;
}
* >>> .vpd-content {
  background-color: #171515 !important;
}
</style>
